import { FormControl } from '@angular/forms';
import { InstructorAvaibilityInInstructorDetail } from 'src/app/pages/members/pages/instructors/models';
import { InstructorInstrument } from 'src/app/pages/scheduler/pages/scheduler-wrapper/pages/schedule/models';

export interface LeaveRequestDetails {
  id: number;
  profilePhoto: string;
  leaveType: number;
  requestDate: string;
  leaveStartDate: string;
  leaveEndDate: string;
  leaveStartTime: string;
  leaveEndTime: string;
  reason: string;
  status: number;
  remark: string;
  peopleToNotify: string[];
  requestedBy: string;
  approvedBy: string;
  requestedById: number;
  approvedById: number;
  approveDate: string;
  role: string;
  substituteName: string | null;
  substituteDetailsId: number;
  requesterAvailabilities: InstructorAvaibilityInInstructorDetail[];
  requestInstruments: InstructorInstrument[];
  unpaidUsedLeaveDays: number;
  paidUsedLeaveDays: number;
}

export interface LeaveApprovalForm {
  requestId: FormControl<number | undefined>;
  remark: FormControl<string | null>;
  status: FormControl<number>;
  substituteDetailsId: FormControl<number | undefined>;
}

export interface AddLeaveRequestForm {
  id: FormControl<number | null>;
  leaveType: FormControl<number | undefined>;
  requestDate: FormControl<string>;
  leaveStartDate: FormControl<string | null>;
  leaveEndDate: FormControl<string | null>;
  reason: FormControl<string>;
  peopleToNotify: FormControl<Array<string>>;
  leaveStartTime: FormControl<string | null>;
  leaveEndTime: FormControl<string | null>;
}

export interface SubstituteAvailabilityRequest {
  requestId: number | undefined;
  locationId: Array<number> | undefined;
  instrumentDetails: Array<InstrumentForSubstitute> | undefined;
  leaveStartDate: string;
  leaveEndDate: string;
  leaveStartTime: string;
  leaveEndTime: string;
  daysOfSchedule: Array<number> | undefined;
}

export interface InstrumentForSubstitute {
  instrumentId: number;
  isIntroductoryAvaLable: boolean;
  skillType: string;
}

export interface FiscalYearDropdown {
  label: string;
  startDate: string;
  endDate: string;
}

export interface LeaveRequestFilter {
  searchTerm: string | null;
  statusFilter: number;
  isSelf: number;
  fromDateFilter: string;
  toDateFilter: string;
}

export interface LeaveBalance {
  leaveType: number;
  remainingLeaveDays: number;
  totalLeaveDays: number;
  usedLeaveDays: number;
  memberDayViseLeaves: Array<MemberDayViseLeave>;
}

export interface MemberDayViseLeave {
  day: number;
  usedLeaveDays: number;
  remainingLeaveDays: number;
  totalLeaveDays: number;
  usedUnpaidLeaveDays?: number;
}

export interface IdEmail {
  id: number;
  email: string;
}

export enum LeaveStatus {
  PENDING_ACTION = 1,
  APPROVED = 2,
  REJECTED = 3
}

export enum LeaveType {
  PAID = 1,
  UNPAID = 2
}

export enum IsSelf {
  FALSE = 1,
  TRUE = 2
}

export const LEAVE_YEAR_FORMATS = {
  parse: {
    dateInput: 'YYYY'
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY'
  }
};

export enum LeaveDurationType {
  FULL_DAY = 1,
  CUSTOM = 2
}
